<template>
  <ejs-toast ref="notifierToastRef"
             id="notifierToast"
             :show-close-button="true"
             :time-out="0"
             :animation="displayAnimation"
             :position="toastPosition"
             :click="onToastClick" />
</template>

<script>
import Vue from 'vue';
import { ToastPlugin } from '@syncfusion/ej2-vue-notifications';

Vue.use(ToastPlugin);

export default {
  name: 'SccFormValidator',
  props: {
    toasts: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  mounted() {
  },
  data() {
    return {
      toastPosition: { X: 'Right', Y: 'Top' },
      displayAnimation: {
        show: { effect: 'ZoomIn' },
        hide: { effect: 'ZoomOut' },
      },
      displayInterval: 500,
    };
  },
  methods: {
    onToastClick(e) {
      e.clickToClose = true;
    },
    show() {
      let totalToasts = null;
      const self = this;
      if (self.toasts !== null && self.toasts.length > 0) {
        totalToasts = [...self.toasts];
        (function loopWithDelay(i) {
          setTimeout(() => {
            self.$refs.notifierToastRef.show(totalToasts[i - 1]);
            // eslint-disable-next-line no-param-reassign
            i -= 1;
            if (i) loopWithDelay(i);
          }, self.displayInterval);
        }(totalToasts.length));
        this.toasts.length = 0;
      }
    },
  },
};
</script>
